export default __webpack_public_path__ + "static/social-illustration-dark-6914ad15f5f8b3c0f27e6829f621ce58.svg";